import HTTP from "@/_helpers/http";
import { MAM__API } from "@/_helpers/urls";
import { MAM__MUTATIONS } from "../mutation-types";
import { MAM__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    investorLists: [],  // ✅ Keep this name
    isLoading: false,
    pagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [MAM__MUTATIONS.GETALLINVESTORS](state, data) {  // ✅ Fixed mutation name to match action
        state.investorLists = data.data;  // ✅ Changed from mamlists to investorLists
        state.pagination = {
            total: data.total,
            perPage: data.perPage,
            currentPage: data.page,
            lastPage: data.lastPage
        };
    },
    
    SET_LOADING(state, data) {
        state.isLoading = data;
    },
};

// Actions
const actions = {
    async [MAM__ACTIONS.GETALLINVESTORS]({ commit }, parameter = {}) {
        try {
            commit("SET_LOADING", true);

            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${MAM__API.GETALLINVESTORS}${queryParams ? `?${queryParams}` : ''}`
            );

            commit(MAM__MUTATIONS.GETALLINVESTORS, response.data);  // ✅ Fixed mutation name
            commit("SET_LOADING", false);
        } catch (error) {
            console.error("Error fetching investors:", error);
            commit("SET_LOADING", false);  // ✅ Reset loading on error
            toast.error("Failed to fetch investors");  // ✅ Show error to user
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};